import ErrorState from '@rio-cloud/rio-uikit/ErrorState';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { configureReporting, SentryErrorInfo } from '../setup/errorReporting';

const { captureException } = configureReporting(window, import.meta.env);

interface Props {
    children?: React.ReactNode;
}

interface State {
    hasError: boolean;
}
export default class ErrorBoundary extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo): void {
        captureException(error, info as unknown as SentryErrorInfo);
    }

    render(): React.ReactNode {
        return this.state.hasError ? (
            <ErrorState headline={<FormattedMessage id="error.default" />} />
        ) : (
            this.props.children
        );
    }
}
